module.exports = __webpack_public_path__ + "media/images/fr/rejected-6be0791cbe2d267583aa337aa3e4f081.png";